import {FC} from 'react';

import {UserAddress} from 'types';

import {AddressDrawerView} from './AddressDrawer';

export type AddressDrawerProps = {
  title: string;
  open: boolean;
  toggleAddressDrawer: () => void;
  onEditAddress?: (address: UserAddress) => void;
  shippingAddress: UserAddress | undefined;
  onNewAddress: () => void;
  updateStoresForBasket: (address: UserAddress) => Promise<void>;
};

export const AddressDrawer: FC<AddressDrawerProps> = (props) => {
  return <AddressDrawerView {...props} />;
};

AddressDrawer.displayName = 'AddressDrawer';
export default AddressDrawer;
